<template>
  <div class="page t-container">
    <section
      class="t-mt-12 t-flex-col t-space-y-8 lg:t-space-y-0 lg:t-flex-row"
      role="main"
    >
      <div class="t-flex t-flex-col t-space-y-8 lg:t-w-full lg:t-mr-8">
        <section
          class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white"
        >
          <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
            <h3 class="t-text-xl t-font-bold">
              Carrier DIFOT Report
            </h3>
          </div>
          <div v-if="!monthlyDifotLoading && !yearlyDifotLoading">
            <div class="mb-3">
              <bar-chart
                :chart-data="monthlyDifotData"
                :options="monthlyDifotOptions"
                v-if="!monthlyDifotLoading"
              ></bar-chart>
            </div>
            <hr class="mt-3" />
            <div>
              <line-chart
                :chart-data="yearlyDifotData"
                :options="yearlyDifotOptions"
                v-if="!yearlyDifotLoading"
              ></line-chart>
            </div>
          </div>
          <div v-else><h4 class="t-text-lg t-pt-4">Loading...</h4></div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import BarChart from "../../components/charts/BarChart.js";
import LineChart from "../../components/charts/LineChart.js";
export default {
  name: "CarrierDifot",
  data() {
    return {
      monthlyDifotData: null,
      monthlyDifotOptions: [],
      monthlyDifotLoading: true,
      yearlyDifotData: null,
      yearlyDifotOptions: [],
      yearlyDifotLoading: true
    };
  },
  components: {
    BarChart,
    LineChart
  },
  mounted() {
    this.getMonthlyDifotData();
    this.getYearlyDifotData();
  },
  methods: {
    getMonthlyDifotData() {
      axios.get("difot/monthlyDifot").then(res => {
        this.monthlyDifotData = {
          labels: res.data.labels,
          datasets: [
            {
              label: "Late Bookings",
              data: res.data.difotData,
              backgroundColor: "rgb(220, 53, 69, .8)",
              borderColor: "rgb(220, 53, 69, 1)",
              borderWidth: 1
            },
            {
              label: "Total Bookings",
              data: res.data.totalBookings,
              backgroundColor: "rgb(0, 116, 217, .3)",
              borderColor: "rgb(0, 116, 217, .5)",
              borderWidth: 1
            }
          ]
        };

        this.monthlyDifotOptions = {
          title: {
            display: true,
            text: "DIFOT for the Past 12 Months",
            fontSize: 24
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{ stacked: true }],
            yAxes: [
              {
                stacked: false,
                ticks: {
                  beginAtZero: true
                },
                scaleLabel: {
                  display: true,
                  labelString: "Total Deliveries"
                }
              }
            ]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return (
                  tooltipItem.value +
                  "(" +
                  Math.round(
                    (data.datasets[0].data[tooltipItem.index] /
                      data.datasets[1].data[tooltipItem.index]) *
                      100
                  ) +
                  "% late)"
                );
              }
            }
          }
        };

        this.monthlyDifotLoading = false;
      });
    },
    getYearlyDifotData() {
      axios.get("difot/yearlyDifot").then(res => {
        this.yearlyDifotData = {
          labels: res.data.labels,
          datasets: [
            {
              label: res.data.thisYearLabel,
              data: res.data.thisYear,
              backgroundColor: "rgb(0, 116, 217, .3)",
              borderColor: "rgb(0, 116, 217, .5)",
              borderWidth: 1
            },
            {
              label: res.data.lastYearLabel,
              data: res.data.lastYear,
              backgroundColor: "rgb(46, 204, 64, .3)",
              borderColor: "rgb(46, 204, 64, .8)",
              borderWidth: 1
            }
          ]
        };

        this.yearlyDifotOptions = {
          title: {
            display: true,
            text: "% of Bookings Delivered Year over Year",
            fontSize: 24
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{ stacked: true }],
            yAxes: [
              {
                stacked: false,
                ticks: {
                  beginAtZero: true
                },
                scaleLabel: {
                  display: true,
                  labelString: "% of Bookings Delivered on Time"
                }
              }
            ]
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem, data) {
                return tooltipItem.value + "%";
              }
            }
          }
        };

        this.yearlyDifotLoading = false;
      });
    }
  }
};
</script>
